'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthPolicyEditPage, IDP_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/idp/_layout/policies/$id/')({
  component: AuthPolicyEditRoute
});
function AuthPolicyEditRoute() {
  const {
    id
  } = Route.useParams();
  return <AuthPolicyEditPage paths={IDP_AUTH_POLICY_PATHS} id={id} />;
}